import React from 'react';
import SingleDatePicker from '../../../components/SingleDatePicker';
import { todayKST } from '../../../utils/date';
import { inputStyle, helperTextStyle } from './styles';
import { normalizeAttendanceTimeType } from './utils';

export default function WorkScheduleEffectiveFields({ editing, form, setForm, attendanceTypeOptions }) {
  if (!editing) return null;

  const currentType = normalizeAttendanceTimeType(form.attendance_time_type, attendanceTypeOptions);
  const originalType = normalizeAttendanceTimeType(form.original_attendance_time_type, attendanceTypeOptions);
  if (currentType === originalType) return null;

  const effectiveDate = form.work_schedule_effective_from || todayKST();

  function updateField(key, value) {
    setForm({ ...form, [key]: value });
  }

  return (
    <div style={panelStyle}>
      <div style={titleStyle}>근무유형 적용 시작일</div>
      <div style={dateBadgeStyle}>적용 시작일 {effectiveDate}</div>
      <SingleDatePicker
        value={effectiveDate}
        onChange={(ymd) => updateField('work_schedule_effective_from', ymd)}
      />
      <textarea
        style={{ ...inputStyle, minHeight: 56, resize: 'vertical' }}
        placeholder="변경 사유 또는 메모"
        value={form.work_schedule_reason || ''}
        onChange={(e) => updateField('work_schedule_reason', e.target.value)}
      />
      <p style={helperTextStyle}>
        달력에서 날짜를 누르면 그 날짜부터 이 근무유형이 적용됩니다. 과거 날짜를 고르면 해당 기간의 출퇴근/급여/연차 기준도 바뀔 수 있습니다.
      </p>
    </div>
  );
}

const panelStyle = {
  gridColumn: '1 / -1',
  display: 'grid',
  gap: 10,
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: 12,
  background: 'var(--bg-subtle)',
};

const titleStyle = {
  fontWeight: 800,
  color: 'var(--text)',
  fontSize: 13,
};

const dateBadgeStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '8px 10px',
  background: 'var(--bg-card)',
  color: 'var(--text)',
  fontSize: 12,
  fontWeight: 800,
};
